export default "__VITE_ASSET__CrXuPumA__"